import { AlNavigationService } from '@al/ng-navigation-components';
import { AlResponderClient, AlResponderLimitContent } from '@al/responder';
import { Injectable } from '@angular/core';

const DEFAULT_USER_LIMITS: { [key: string]: number } = {
    tasks_per_playbook: 30,
    exclusions: 50,
};

@Injectable({
    providedIn: 'root'
})
export class AlResponderUserLimitsService {

    private accountId: string | undefined;
    private limits: { [key: string]: AlResponderLimitContent; } = {};

    constructor(private alNavigation: AlNavigationService) { }

    public async limitReached(accountId: string, feature: string, currentCount?: number): Promise<boolean> {
        if (!this.alNavigation.isExperienceAvailableSync('automated-response#limits')) {
            return false;
        }
        await this.loadLimitsByAccount(accountId);
        currentCount = currentCount ?? this.limits[feature].count;
        if (feature in this.limits) {
            return currentCount >= this.limits[feature].max_count;
        }
        return false;
    }

    public async forceReload(): Promise<void> {
        if (this.accountId) {
            await this.loadLimitsByAccount(this.accountId, true);
        }
    }

    private async loadLimitsByAccount(accountId: string, forceReload: boolean = false): Promise<void> {
        if (this.accountId !== accountId || forceReload) {
            try {
                this.limits = (await AlResponderClient.getLimits(accountId)).limits;
                this.accountId = accountId;
            } catch (err) {
                console.warn('Reponse Customer limits endpoint is not working, using defaults responder limits');
                this.limits = {};
            } finally {
                // Remove this when backend return all limits.
                for (const key in DEFAULT_USER_LIMITS) {
                    if (Object.prototype.hasOwnProperty.call(DEFAULT_USER_LIMITS, key)) {
                        const limit = DEFAULT_USER_LIMITS[key];
                        if (!(key in this.limits)) {
                            this.limits[key] = { max_count: limit, count: 0 };
                        }
                    }
                }
                return;
            }
        }
        return;
    }
}
